import React from "react";
import { Button } from "react-bootstrap";
import WarningModal from "../WarningModal";

const GrossAmountWarningModal = ({
  showModal,
  WarningToastMessage,
  WarningToastMessageHead,
  handleOkayClick,
}) => {
  return (
    <WarningModal
      show={showModal}
      onHide={handleOkayClick}
      DeleteToastMessage={WarningToastMessage}
      DeleteToastMessageHead={WarningToastMessageHead}
    >
      <div className="msg-headtext">
        <h4 style={{ paddingRight: "50px" }}>{WarningToastMessageHead}</h4>
        <div style={{ marginBottom: "10px" }}>
          <p>{WarningToastMessage} </p>
          <p style={{ marginTop: "5px", marginBottom: "10px" }}></p>
        </div>

        <div className="btnsDeleteCancelMapper">
          <Button
            className="cancelButtonWarningMapper"
            onClick={handleOkayClick}
          >
            Okay
          </Button>
        </div>
      </div>
    </WarningModal>
  );
};

export default GrossAmountWarningModal;
